"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var classnames_1 = __importDefault(require("classnames"));
var react_jss_1 = require("react-jss");
var __1 = require("../..");
var styles_1 = __importDefault(require("./styles"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
// eslint-disable-next-line no-redeclare, import/export
var Modal = function (_a) {
    var title = _a.title, description = _a.description, image = _a.image, children = _a.children, showModal = _a.showModal, onRequestClose = _a.onRequestClose, primaryCTA = _a.primaryCTA, secondaryCTA = _a.secondaryCTA;
    var classes = useStyles();
    var imageClassNames = image && (0, classnames_1.default)(image.props.className, classes.image);
    return (react_1.default.createElement(react_modal_1.default, { htmlOpenClassName: classes.stopScroll, className: classes.root, contentLabel: title, isOpen: showModal, onRequestClose: onRequestClose, shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, style: {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 100
            }
        } },
        react_1.default.createElement("button", { onClick: onRequestClose, className: classes.close, "aria-label": "Close modal" },
            react_1.default.createElement(__1.ActionClose, { color: "gray500", size: "large", ariaHidden: true })),
        image && react_1.default.cloneElement(image, { className: imageClassNames }),
        react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(__1.TitleText, { size: "large", className: classes.titleText }, title),
            description && (react_1.default.createElement(__1.BodyText, { className: classes.description }, description)),
            react_1.default.createElement("div", { className: classes.body }, children),
            (primaryCTA || secondaryCTA) && (react_1.default.createElement("div", { className: classes.CTA },
                secondaryCTA && (react_1.default.createElement(__1.Button, __assign({ variant: "quaternary", size: "large", className: classes.secondaryCTA }, secondaryCTA), secondaryCTA.text)),
                primaryCTA && (react_1.default.createElement(__1.Button, __assign({ color: "primary", size: "large" }, primaryCTA), primaryCTA.text)))))));
};
exports.Modal = Modal;
exports.Modal.setAppElement = react_modal_1.default.setAppElement;
